import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import api from '../../lib/api';
import { auth } from '../../lib/firebase';

export interface SignupPayload {
  email: string;
  password: string;
  name: string;
}

export interface User {
  id: string;
  email: string;
  name?: string;
}

export interface SignupResponse {
  token: string;
  user: User;
}

export const useSignup = () => {
  const queryClient = useQueryClient();

  return useMutation<SignupResponse, any, SignupPayload>({
    mutationFn: async ({ email, password, name }) => {
      // 1️⃣ Create user with Firebase
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);

      // Optional: set display name in Firebase
      if (name) {
        await updateProfile(userCredential.user, { displayName: name });
      }

      const token = await userCredential.user.getIdToken();

      // await api.post(
      //   "/users/sync",
      //   {},
      //   { headers: { Authorization: `Bearer ${token}` } }
      // );

      const res = await api.get('/users', {
        headers: { Authorization: `Bearer ${token}` },
      });

      const user = res.data.user;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      return { token, user };
    },
    onSuccess: (data) => {
      queryClient.setQueryData(['authUser'], data.user);
    },
  });
};
